// Party soundtrack. The served manifest (assets/music.json) is a prebuilt
// artifact (deno task build:music) joined from data/music/{artists,songs}.json.
// The client just reads it — no joining at the edge.
//
// `ai: true` marks AI-generated tracks; the player surfaces that visually and
// never presents them as a human artist.

export interface Track {
  title: string;
  artist: string; // human artist name, or the AI tool (with ai: true)
  ai: boolean; // AI-generated?
  src: string; // ready-to-play URL under /assets/music/{real,ai}/
  url?: string; // artist / source link (human artists)
  prompt?: string; // generation prompt (AI tracks)
}

export interface MusicManifest {
  tracks: Track[];
}

const EMPTY: MusicManifest = { tracks: [] };

export async function loadMusic(): Promise<MusicManifest> {
  try {
    const res = await fetch("/assets/music.json");
    if (!res.ok) return EMPTY;
    return (await res.json()) as MusicManifest;
  } catch {
    return EMPTY; // party still works in silence
  }
}
